import React, { useEffect, useState, useRef } from 'react'
import MultiSelectEntity from '../RefineSearch/TgMultiSelectEntity'
import { FilterFundInvestor , FilterREFundInvestor } from "../../Config/config"

function FundInvestor({ open, accordionClick, options, setOptions, customPathname, label }) {

    const [companyVal, setCompanyVal] = useState("");
    const [fetchedData, setFetchedData] = useState([]);
    const [isFocused, setIsFocused] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const inputRef = useRef(null);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            if (companyVal.trim() !== "") {
                fetchData();
            } else {
                setShowDropdown(false);
            }
        }, 300);

        return () => clearTimeout(delayDebounceFn);
    }, [companyVal]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target) && 
                inputRef.current && !inputRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    
    const fetchData = () => {
        const payload = {
            search_key: companyVal,
            type: customPathname.includes("vc/investors") ? "VC" : "PE",
        };
        const filter = customPathname.includes("pe/investors") || customPathname.includes("vc/investors") ? FilterFundInvestor : FilterREFundInvestor;

        fetch(filter, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                if (data?.results) {
                    setFetchedData(data?.results); 
                    setShowDropdown(true);
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
                setFetchedData([]);
                setShowDropdown(false);
            });
    }

    useEffect(() => {
        const uniqueFetchedData = fetchedData.filter(item => !options.some(option => option.id === item.id));
        setOptions(prevOptions => [...prevOptions.filter(item => item.isChecked === true), ...uniqueFetchedData]);
    }, [fetchedData]);

    const handleIndustryChange = ((e) => {
        const { name, checked, id } = e.target;
        let currentIndustry = [];

        if (name === "allSelect") {
            currentIndustry = options.map((industry) =>
                ({ ...industry, isChecked: checked })
            );
            setOptions(currentIndustry);
        } else {
            currentIndustry = options.map((industry) =>
                industry.id === parseInt(id) ? { ...industry, isChecked: checked } : industry
            );
            setOptions(currentIndustry);
        }
    });

    const selectedIndustryLength = options?.filter(option => option.isChecked)?.length ?? 0;
    const hasValue = companyVal || selectedIndustryLength > 0;

    return (
        <div className="relative">
            <div className={`absolute left-3 transition-all duration-200 pointer-events-none flex items-center gap-2 z-10 ${
                isFocused || hasValue 
                    ? 'top-0 -translate-y-1/2 text-xs bg-white px-1 text-[#BC8B20]' 
                    : 'top-1/2 -translate-y-1/2 text-sm text-gray-500'
            }`}>
                <span>{label}</span>
                {(isFocused || hasValue) && selectedIndustryLength > 0 && (
                    <span className="bg-white rounded-full px-2 py-0.5 text-xs font-medium border border-gray-400">
                        {selectedIndustryLength}
                    </span>
                )}
            </div>
            
            <div className="relative border border-gray-400 rounded-lg bg-white">
                <input
                    ref={inputRef}
                    type="text"
                    value={companyVal}
                    onChange={(e) => setCompanyVal(e.target.value)}
                    onFocus={() => {
                        setIsFocused(true);
                        if (fetchedData.length > 0) {
                            setShowDropdown(true);
                        }
                    }}
                    onBlur={() => {
                        setTimeout(() => setIsFocused(false), 200);
                    }}
                    className="w-full px-4 py-2 rounded-lg focus:outline-none bg-transparent"
                    placeholder=""
                />
            </div>
            
            {/* Search Results Dropdown */}
            {showDropdown && fetchedData.length > 0 && (
                <div ref={dropdownRef} className="px-2 absolute z-50 w-full top-full mt-1 bg-white border border-gray-100 rounded-sm shadow-lg max-h-64 overflow-y-auto">
                    <MultiSelectEntity
                        fetchData={fetchData}
                        handleEntityChange={handleIndustryChange}
                        primaryEntity={options}
                        setCompanyVal={setCompanyVal}
                        city="city"
                    />
                </div>
            )}
        </div>
    )
}

export default FundInvestor;
